module.exports = __webpack_public_path__ + "img/default-used.c9c3433e.png";